<template>
  <div class="lms-course-card border rounded p-3 mb-3 bg-white" :class="{ 'border-primary': settings.is_enabled }">
    <div class="d-flex flex-wrap align-items-start justify-content-between">
      <div class="d-flex align-items-start" style="gap:12px; flex:1; min-width:240px;">
        <div class="lms-icon-wrap">
          <i class="fas fa-graduation-cap"></i>
        </div>
        <div>
          <div class="d-flex align-items-center flex-wrap" style="gap:6px;">
            <span class="badge badge-primary">LMS / Kursus</span>
            <span class="badge" :class="settings.is_enabled ? 'badge-success' : 'badge-secondary'">
              {{ settings.is_enabled ? 'Aktif' : 'Nonaktif' }}
            </span>
          </div>
          <h5 class="mb-1 mt-2">Kursus Online</h5>
          <div v-if="settings.is_enabled" class="mb-2">
            <small class="text-muted">
              {{ stats.total_courses || 0 }} kursus aktif · {{ stats.total_count || 0 }} siswa ·
              {{ formatRupiah(stats.total_amount) }} pendapatan
            </small>
          </div>
          <p v-else class="text-muted small mb-0">LMS belum diaktifkan. Aktifkan untuk jual kursus online di toko.</p>
        </div>
      </div>
      <div class="d-flex flex-wrap mt-2 mt-md-0" style="gap:6px;">
        <button class="btn btn-sm btn-primary" @click="$emit('edit')">
          <i class="fas fa-cog"></i> {{ settings.is_enabled ? 'Pengaturan' : 'Aktifkan' }}
        </button>
        <button v-if="settings.is_enabled" class="btn btn-sm btn-success" @click="$emit('add-course')">
          <i class="fas fa-plus"></i> Tambah Kursus
        </button>
        <router-link v-if="settings.is_enabled" :to="'/shop/' + shopId + '/lms/enrollments'" class="btn btn-sm btn-outline-info">
          <i class="fas fa-users"></i> Siswa
        </router-link>
        <button v-if="settings.is_enabled && shopSlug" class="btn btn-sm btn-outline-secondary" @click="copyLink">
          <i class="fas fa-link"></i> Salin Link
        </button>
        <a v-if="settings.is_enabled && shopSlug" :href="catalogUrl" target="_blank" class="btn btn-sm btn-light">
          <i class="fas fa-external-link-alt"></i>
        </a>
      </div>
    </div>

    <div v-if="settings.is_enabled && courses.length > 0" class="mt-3 pt-3 border-top">
      <div v-for="course in courses" :key="course.id" class="d-flex align-items-center justify-content-between py-2 border-bottom">
        <div class="d-flex align-items-center" style="gap:10px;">
          <img v-if="course.cover_image_url" :src="course.cover_image_url" style="width:48px;height:48px;object-fit:cover;border-radius:6px;">
          <div v-else class="course-thumb-placeholder"><i class="fas fa-book"></i></div>
          <div>
            <b>{{ course.title }}</b>
            <small class="d-block text-muted">
              {{ course.price > 0 ? formatRupiah(course.price) : 'Gratis' }} ·
              <span :class="course.status === 'active' ? 'text-success' : 'text-muted'">{{ course.status }}</span>
            </small>
          </div>
        </div>
        <div style="gap:4px;" class="d-flex">
          <button class="btn btn-sm btn-outline-primary" @click="$emit('edit-course', course.id)"><i class="fas fa-edit"></i></button>
          <button class="btn btn-sm btn-outline-danger" @click="$emit('delete-course', course.id)"><i class="fas fa-trash"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LMSCourseCard',
  props: {
    shopId: { type: Number, required: true },
    shopSlug: { type: String, default: '' },
    settings: { type: Object, required: true },
    stats: { type: Object, default: () => ({ total_courses: 0, total_count: 0, total_amount: 0 }) },
    courses: { type: Array, default: () => [] },
  },
  computed: {
    catalogUrl() {
      return window.location.origin + '/toko/' + this.shopSlug + '/kursus';
    },
  },
  methods: {
    formatRupiah(v) { return 'Rp ' + (v || 0).toLocaleString('id-ID'); },
    copyLink() {
      navigator.clipboard.writeText(this.catalogUrl).then(() => {
        this.$toast.success('Link katalog kursus disalin');
      }).catch(() => { this.$toast.info(this.catalogUrl); });
    },
  },
};
</script>

<style scoped>
.lms-icon-wrap {
  width: 56px; height: 56px; border-radius: 12px;
  background: linear-gradient(135deg, #1565c0, #42a5f5);
  color: white; display: flex; align-items: center; justify-content: center;
  font-size: 22px; flex-shrink: 0;
}
.lms-course-card { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.course-thumb-placeholder {
  width: 48px; height: 48px; border-radius: 6px; background: #e3f2fd;
  display: flex; align-items: center; justify-content: center; color: #1565c0;
}
</style>
